module.exports = __webpack_public_path__ + "img/info.5912569d.svg";